<template>
  <div class="titledata">
    <div class="title">
      {{ titledata }}
    </div>
  </div>
</template>

<script>
export default {
  props: ["titledata"],
  methods: {},
};
</script>

<style lang="scss" scoped>
.titledata {
  position: relative;
  color: #151a86;
  left: 0rem;
  right: 0.05rem;
  line-height: 0.21rem;
  width: 100%;
  border-bottom: 1px solid;
  border-image: -webkit-linear-gradient(left, rgba($color: #0f69ca, $alpha: .5) 0% , rgba($color: #0f69ca, $alpha: .5) 90%, rgba($color: #0f69ca, $alpha: 0.0) 91%, rgba($color: #0f69ca, $alpha: 0.0) 100%) 1 12;
  // border-image: linear-gradient(left, rgba($color: #0f69ca, $alpha: .5) 0%, rgba($color: #0f69ca, $alpha: .5) 80%,rgba($color: #0f69ca, $alpha: 0) 81%,rgba($color: #0f69ca, $alpha: 0) 100%);
  height: 0.21rem;
}
.titledata::after {
  content: " ";
  display: block;
  position: absolute;
  right: 0;
  bottom: -0.01rem;
  width: 0.025rem;
  height: 0.012rem;
  background: #0f69ca;
}
.title {
  text-shadow: 3px 2px 5px #fff;
  font-size: 0.090rem;
  font-weight: 600;
  user-select: none;
  position: absolute;
  height: 0.21rem;
  left: 0;
  top: 0;
  padding: 0 0.02rem 0 0;
  border-bottom: 0.015rem solid #151a86;
}
.title::after {
  content: " ";
  display: block;
  position: absolute;
  height: 0.09rem;
  top: 0.06rem;
  right: -.55rem;
  width: .5rem;
  border-left:.015rem solid  #151a86;
   background: linear-gradient(left, rgba(#151a86, .4), rgba(#151a86, 0));
  //  background: gradient(linear,0% 0%,100% 100%, rgba(#0f69ca, .4), rgba(#0f69ca, 0));
  // background-image: url(./t_r.png);
  background-repeat: no-repeat;
  background-size:100% 80% ;
  background-position: center center;
}
</style>



// WEBPACK FOOTER //
// src/components/webgl/ui/pop/pophead.vue